export const messages = {
  page: {
    title: {
      id: 'signup.ProvideIdentity.Title',
      defaultMessage: 'Enter Your Email Address',
    },
    instruction: {
      id: 'signup.ProvideIdentity.Page.VerifyInfo',
      defaultMessage: `We require your email address to create your account. 
        It will be kept private as part of your account information, and you won't have to enter it again.`,
    },
  },
  button: {
    continue: {
      id: 'signup.ProvideIdentity.Button.Continue',
      defaultMessage: 'Continue',
    },
  },
};
